<template>
  <div class="perguntasFrequentes">
    <BannerPerguntasFrequentes/>
    <TextPerguntasFrequentes/>
    <FormPerguntasFrequentes/>
  </div>
</template>

<script>
import BannerPerguntasFrequentes from '@/wrappers/BannerPerguntasFrequentes'
import TextPerguntasFrequentes from '@/wrappers/TextPerguntasFrequentes'
import FormPerguntasFrequentes from '@/wrappers/FormPerguntasFrequentes'
export default {
  name: 'perguntasFrequentes',
  components: {
    BannerPerguntasFrequentes,
    TextPerguntasFrequentes,
    FormPerguntasFrequentes,
  }
}
</script>